import React, {CSSProperties} from 'react';
import classNames from 'classnames';
import {
  Button,
  DiscOneIcon,
  DiscTwoIcon,
  DiscThreeIcon,
  DiscFourIcon,
  DiscFiveIcon,
  RadioCheckMarkCheckedIcon,
  Icon,
} from '@taopix/taopix-design-system';
import {useUiState} from '../../../Context/UserInterface/UserInterfaceContext';

type BreadCrumbTrailProps = {
  items: {label: string; onClick: (event: React.MouseEvent) => void; clickable: boolean}[];
  selectedItemIndex?: number;
  classes?: string;
};

export const BreadCrumbTrail = ({
  items,
  selectedItemIndex = 0,
  classes = '',
}: BreadCrumbTrailProps) => {
  const ui = useUiState();
  const listClasses = classNames('flex', 'grow', 'justify-between', 'max-w-[1000rem]', classes);
  const itemClasses = classNames(
    'relative',
    'flex',
    'justify-center',
    'w-[calc(100%_/_var(--tpx-assistant-steps-count))]',
    // Adjoining line
    'before:w-[calc(100%-26rem)]',
    'before:bg-themeTextColour',
    'before:left-[calc(0rem-(50%-13rem))]',
    'before:h-[2rem]',
    'before:absolute',
    '',
    ui.state.isSmallScreen ? 'before:top-[19rem]' : 'before:top-[11rem]',
    // Do not show a line for the first item
    'first:before:content-none'
  );

  const icons = {
    0: <DiscOneIcon />,
    1: <DiscTwoIcon />,
    2: <DiscThreeIcon />,
    3: <DiscFourIcon />,
    4: <DiscFiveIcon />,
  };

  const breadCrumbCSSProperties = {'--tpx-assistant-steps-count': items.length} as CSSProperties;

  return (
    <ul className={listClasses} style={breadCrumbCSSProperties}>
      {items.map((item, index) => {
        // If the item is the current step, or not clickable, or its index is greater than the next item, disable it.
        // (the current step will use the pressed appearance)
        const disabled =
          !item.clickable || index === selectedItemIndex || index > selectedItemIndex + 1;
        const lineClass = index > selectedItemIndex && 'before:opacity-10';
        const thisItemClasses = classNames(itemClasses, lineClass);
        return (
          <li key={`breadcrumbtrail-${item.label}`} className={thisItemClasses}>
            <Button
              label={item.label}
              hideLabel={ui.state.isSmallScreen}
              stacked
              boxless
              buttonStyle={'standard'}
              startIcon={
                index === selectedItemIndex ? (
                  <Icon icon={icons[index]} colour={'themeAccentColour'} />
                ) : index < selectedItemIndex ? (
                  <RadioCheckMarkCheckedIcon />
                ) : (
                  icons[index]
                )
              }
              aria-pressed={index === selectedItemIndex}
              disabled={disabled}
              onClick={(e: React.MouseEvent) => item.onClick(e)}
            />
          </li>
        );
      })}
    </ul>
  );
};
